import { Button, Card, CardActions, CardContent, CardMedia, Checkbox, Divider, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/system';
import * as React from 'react';
import { Stack } from '@mui/material';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import backgroundpicture from "../images/SCADA/oofShorePark.png"

import { TemperatureMeter } from '../components/oilSensor/tempSpeedometer'
import { OilDegredationMeter } from '../components/oilSensor/oilDegredationSpeedometer';
import {ISO4406Meter} from '../components/oilSensor/ISO4406Meter';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { useDispatch } from 'react-redux';
import { unSelect } from '../features/WTG/TurbineSlice';
import { fetchValues } from '../API';

import OilImage from "../images/SCADA/Oil.svg"


import SpeedIcon from '@mui/icons-material/Speed';
import BarChartIcon from '@mui/icons-material/BarChart';
import SsidChartIcon from '@mui/icons-material/SsidChart';
import CameraIcon from '@mui/icons-material/Camera';

import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import Iso4406LineChart from '../components/oilSensor/Charts/Iso4406Charts';
import OilTempChart from '../components/oilSensor/Charts/oilTempChart';
import OilConditionChart from '../components/oilSensor/Charts/oilConditionChart';
import ParticleChart from '../components/oilSensor/Charts/oilBubbleParticleChartVs2';

import RadarChartFunc from '../components/oilSensor/Charts/RadarChart';
import { CheckCircleOutlineRounded } from '@mui/icons-material';


const lessThan = ">";

const green = '#00c853';
const yello = '#ffab00';
const red = '#dd2c00';
const backgroundColor="#455a64"

let arrowDropDownIcon = <ArrowDropDownIcon style={{color:"#2e7d32"}} />
let arrowDropUpIcon = <ArrowDropUpIcon style={{color:"#b71c1c"}} />

/**
 * Status limits with Warning and Alarm values
 * Array with  "ISO4": ["Warning", "Alarm"]
 */
const BoundaryLimts = {
    "ISO4": ["22", "24"],
    "ISO6": ["20", "22"],
    "ISO14": ["17", "19"],
    "OD": ["60", "80"], 
    "Cutting": ["25", "50"],
    "Fatigue": ["100", "150"],
    "Fiber": ["10", "30"],
    "Sliding": ["10", "30"]
}


/**
* Check gives an ouitlined Check Circle in the color green from MUI
* @param {string} message
*/
const Check = <CheckCircleOutlineIcon  style={{ color: green }} />
/**
* Warning gives an filled Circle in the color orange/yellow from MUI
* @param {string} message
*/
const Warning = <ErrorIcon style={{ color: yello }} />
/**
* Errorgives an ouitlined Erro Circle in the color red from MUI
* @param {string} message
*/
const Error = <ErrorOutlineIcon style={{ color: red }} />

const PaperColor="rgba(55,71,79,0.30)";
// const PaperColor="#37474f";

const PaperSx={
     height: "230px", width: "93%" ,bgcolor:PaperColor , borderRadius:"4%"
}

const TextSx={
    color:"White"
}
let air = 0;
let cutting = 0;
let sliding = 0;
let fatigue = 0;
let fiber = 0;
let OD = 0;
const styles = {
    boxContainer: {
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.85),rgba(0, 0, 0, 0.6)), url(${backgroundpicture})`,
        backgroundSize: "100% 100vh",
        backgroundRepeat: "no-repeat"
    }
  };
  
export default function OilSensorPage(props) {

    const [checked, setChecked] = React.useState(true);

    const handleChange = (event) => {
      setChecked(event.target.checked);
    };
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(unSelect())
    }, []);

    return (
        <Box  className="wrapper" 
        // style={{ backgroundColor:backgroundColor }}
        style ={styles.boxContainer}
        >
         
            <Grid
                container
                marginTop={.5}
                direction="row"
                justifyContent="space-evenly"
                alignItems="flex-start"
                spacing={1}
               
            >
                <Grid  item xs={9}>

                    <Grid container
                    direction="row"
                    justifyContent="center"
                    alignItems="flex-start"
                    spacing={1}
                    >

                  
                    <Grid item xs={11.5}
        
                    >
                        {/* <Paper
                            elevation="10"
                            
                            sx={{ opacity:"0.7", height: "115px", width: "100%", bgcolor:"#37474f" }}
                        > */}
                            <Grid container
                        
                                direction="row" 
                                justifyContent="center"
                                alignItems="center"
                                sx={{ marginTop:"5px", height: "30%", width: "100%" }}
                                
                       
                            >
                                

                                <Grid item xs={12}
                                justifyContent="space-evenly"
                                alignItems="flex-start"
                                height={"70%"}
                               
                                
                                >
                                    <Stack
                                        direction="row"
                                        // sx={{ marginLeft: "10%", marginRight: "50px", height: "100%" }}
                                        // style={{ position: "relative", top: "-30px" }}
                                    
                                    justifyContent="space-evenly"
                                    alignItems="flex-start"
                                    >


                                        {ISOPaper("#558b2f","ISO 4",12,"1" )}  
                                        {ISOPaper("#00acc1","ISO 6",11, "2")}  
                                        {ISOPaper("#424242","ISO 14",19,"3")}         
                
                                        {ISOPaper("#558b2f","ISO 21",8,"4" )}  
                                        {ISOPaper("#00acc1","ISO 38",6, "4")}  
                                        {ISOPaper("#424242","ISO 70",7,"4")}         
                
                                
                                    </Stack>

                                </Grid>
                               



                            </Grid>
                        {/* </Paper> */}
                    </Grid>
                    <Grid item xs={12} height="270px"  >

                                    <Stack justifyContent="space-evenly"
                                    alignItems="flex-start" direction={"row"}>
                                    <Iso4406LineChart/>
                                    </Stack>
                                </Grid>


                    <Grid item xs={11.4} marginTop={5} height="480px">
                        <Paper  

                                elevation={10}
                                sx={{ height: "335px", width: "100%" , bgcolor:"rgba(12, 28, 35,0.70)" }}
                                >
                            <Stack
                      
                            marginLeft={"60px"}
                            alignItems="flex-start">
                                <h3 style={TextSx}
                                 >
                                Oil Degredation Prognosis
                                                                </h3>
                            </Stack>

                            <Stack direction="row"
                             justifyContent="space-evenly"
                             alignItems="flex-start"
                             margin={"-20px"}>
                            <OilConditionChart />

                            <RadarChartFunc/>
                         
                            </Stack>
                                 </Paper>
                    </Grid>
            
                            </Grid>
                    </Grid>
                <Grid item xs={3}>

                    <Grid
                
                    container
                    direction="row" 
                    spacing={3}
                    alignItems="center"
                    justifyContent="center"
                    
                    >
                        
                    <Grid item xs={12}
    
                         
                        >
                            <Paper
                                             elevation="5"
                                sx={PaperSx}

                            >
                                <Grid container

                                    direction="row" spacing={0}
                                    sx={{ height: "100%", width: "100%", opacity:"2" }}
                                  

                                >

                                    <Grid item xs={12}
                                        sx={{ height: "45px", width: "100%" }}
                                    >
                                        <Stack
                                            sx={{ height: "20px", width: "100%", marginTop: "15px", opacity:"2" }}
                                            direction="row" alignItems="center" justifyContent="center">
                                                <Paper 
                                                 style={{ width:"260px", opacity:"2" ,minWidth:"50px",height:"30px",backgroundColor:"#263238", marginBottom:"35px"}}
                                                >
                                            <h4 style={TextSx}>
                                                SYSTEM MONITOR
                                            </h4>
                                                </Paper>
                                        </Stack>
                                    </Grid>

                                    <Grid item xs={12}

                                    >
                                        <Stack
                                            direction="column"
                                            sx={{ marginTop:"-20px",marginLeft: "25px", marginRight: "25px", height: "100%" }}
                                        >
                                            <Stack
                                                direction="row"
                                                justifyContent="space-between"
                                                alignItems="center"
                                                spacing={1}

                                            >

                                                <h6 style={{ padding: "0px", margin: "2px" ,color:"white"}} >
                                                    Cleanliness level
                                                </h6>
                                                {/* {CleanlinessDot(ISO4406)} */}
                                                {CleanlinessDot(10)}

                                            </Stack>
                                            <Divider orientation="horizontal" flexItem />
                                            <Stack
                                                direction="row"
                                                justifyContent="space-between"
                                                alignItems="center"
                                                spacing={1}

                                            >
                                                <h6 style={{ padding: "0px", margin: "2px",color:"white" }}>
                                                    Severe wear
                                                </h6>

                                                {SevereWearDot()}

                                            </Stack>
                                            <Divider orientation="horizontal" flexItem />
                                            <Stack
                                                direction="row"
                                                justifyContent="space-between"
                                                alignItems="center"
                                                spacing={1}

                                            >
                                                <h6 style={{ padding: "0px", margin: "2px" ,color:"white"}}>
                                                    Air content
                                                </h6>

                                                {/* {AirContentDot(Particles.air)} */}
                                                {AirContentDot(10)}

                                            </Stack>
                                            <Divider orientation="horizontal" flexItem />
                                            <Stack
                                                direction="row"
                                                justifyContent="space-between"
                                                alignItems="center"
                                                spacing={1}

                                            >
                                                <h6 style={{ padding: "0px", margin: "2px",color:"white" }}>
                                                    Oil degradation
                                                </h6>
                                                {Dot(OD, BoundaryLimts.OD)}
                    
                                            </Stack>

                                            <Divider orientation="horizontal" flexItem />

                                            <Stack
                                                direction="row"
                                                justifyContent="space-between"
                                                alignItems="center"
                                                spacing={1}

                                            >
                                                <h6 style={{ padding: "0px", margin: "2px",color:"white" }}>
                                                    Fatigue wear
                                                </h6>
                                                {Dot(fatigue, BoundaryLimts.Fatigue)}
                                            
                                            </Stack>
                                            <Divider orientation="horizontal" flexItem />


                                            <Stack
                                                direction="row"
                                                justifyContent="space-between"
                                                alignItems="center"
                                                spacing={1}

                                            >
                                                <h6 style={{ padding: "0px", margin: "2px",color:"white" }}>
                                                    Abrasive wear (Cutting)
                                                </h6>
                                                {Dot(cutting, BoundaryLimts.Cutting)}
                                            
                                            </Stack>
                                            <Divider orientation="horizontal" flexItem />
                                            <Stack
                                                direction="row"
                                                justifyContent="space-between"
                                                alignItems="center"
                                                spacing={1}

                                            >
                                                <h6 style={{ padding: "0px", margin: "2px",color:"white" }}>
                                                    Adhesive wear (sliding)
                                                </h6>
                                                {Dot(sliding, BoundaryLimts.Sliding)}
                                            
                                            </Stack>
                                            <Divider orientation="horizontal" flexItem />

                                            <Stack
                                                direction="row"
                                                justifyContent="space-between"
                                                alignItems="center"
                                                spacing={1}

                                            >
                                                <h6 style={{ padding: "0px", margin: "2px",color:"white" }}>
                                                    Fibre contamination (fibres)
                                                </h6>
                                                {Dot(fiber, BoundaryLimts.Fiber)}
                                            
                                            </Stack>

                                            {/* <Stack
                                                direction="row"
                                                justifyContent="center"
                                                alignItems="center"
                                                spacing={2.5}
                                                style={{ marginTop: "7px" }}>

                                                <Stack
                                                    direction="row"
                                                    justifyContent="space-evenly"
                                                    alignItems="center"
                                                    spacing={1}>

        <CheckCircleIcon  style={{color:green}} fontSize="large"/>

                                                    <h5
                                                    >
                                                        Ok
                                                    </h5>
                                                </Stack>
                                                <Stack
                                                    direction="row"
                                                    justifyContent="space-evenly"
                                                    alignItems="center"
                                                    spacing={1}>

        <ErrorIcon style={{color:yello}} fontSize="large"/>
                                                    <h5>
                                                        Warning
                                                    </h5>
                                                </Stack>

                                                <Stack
                                                    direction="row"
                                                    justifyContent="space-evenly"
                                                    alignItems="center"
                                                    spacing={1}>

        <ErrorIcon fontSize="large" style={{ color: red }}/>
                                                    <h5>
                                                        Alarm
                                                    </h5>
                                                </Stack>
                                            </Stack> */}
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </Paper>
                    </Grid>
                    <Grid item xs={12}
                           
                        >

                            <Paper
                            elevation="10"
                                sx={{  height: "190px", width: "93%", bgcolor:"rgba(33, 49, 56,0.30)" , borderRadius:"4%"}}
                            >
                                <Grid container
                                    direction="row"
                                    sx={{ height: "100%", width: "100%" }}
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    <Grid item xs={12}>
                                        <Grid container direction="row" justifyContent="space-between"
                                    alignItems="center">
                                        <Grid item xs={1}></Grid>
                                        <Grid  container xs={10} justifyContent="center">
 
                                        <Paper 
                                                        style={{opacity:"1", marginTop:"-10px",width:"240px" ,minWidth:"50px",height:"30px",backgroundColor:"#263238", marginBottom:"35px"}}
                                                        >
                                                    <h4 style={TextSx}>
                                                    OIL TEMPTERATURE
                                                    </h4>
                                        </Paper>
                                                {/* <h5 style={{color:"white", marginTop:"20px"}}>
                                                        <DeviceThermostatIcon fontSize="large" style={{color:"white"}} />
                                                        OIL TEMPTERATURE
                                                    </h5> */}
                                                </Grid>
                                    
                                    <Grid item xs={1}>
                                            <Button  style={{marginTop:"-46px", marginLeft:"-5px"}}>
                                                        <Checkbox  
                                                        checked={checked}
                                                        onChange={handleChange}
                                                        icon={<SpeedIcon style={{color:"white"}} fontSize={"large"}/>} checkedIcon={<SsidChartIcon style={{color:"white"}}  fontSize={"large"} />} />
                                            </Button>
                                            </Grid>
                                                        </Grid>
                                     </Grid>

                                    <Grid item xs={12} marginTop="-20px">
                                      {checked ? <TemperatureMeter OilTemp={[10,10,10,10,12,12,12,12,13,13,13,13]} />
                                     :
                                     <OilTempChart OilData={[10,10,10,10,12,12,12,12,12,12,12]} />
                                    }
                                     </Grid>
                                    </Grid>
                            </Paper>
                        </Grid>
                        
                    <Grid item xs={12}>
                   
                                <Grid container
                                marginTop="-20px"
                                    direction="row"
                                    sx={{ width: "93%" }}
                                    justifyContent="center"
                                    alignItems="flex-start"
                                >
                                   <Grid item xs={11}>                                   
                                   </Grid>
                                   <Grid item xs={1}>
                                   <CameraIcon style={{color:"white", marginBottom:"-7px", marginLeft:"0px"}} fontSize={"large"}/>
                                     </Grid>
                                    <Grid item xs={11}> 
                                
                                     <Card   elevation={20}>
                                        <CardMedia
                                            component="img"
                                            height="220px"
                                            
                                            image={OilImage}
                                            alt="green iguana"
                                        />
                                        <CardContent alignItems="flex-start" sx={{alignItems:"flex-start", backgroundColor:"black"}}>
                                            <Typography  sx={{ display:"inline-block", color:"white", alignItems:"flex-start"}}gutterBottom variant="h6">
                                            Current Optical Image
                                            </Typography>
                                        </CardContent>
                                        </Card>
                                     </Grid>
                                    
                                </Grid>
                                  
                    </Grid>
                    </Grid>
                </Grid>
                 
            </Grid>

        </Box>

    )
}

const Dot = (type, limit) => {
    if (type >= limit[0]) {

        if (type >= limit[1]) {
            return Error;
        }
        else {
            return Warning;
        }
    }
    return Check;
}


const CleanlinessDot = (value) => {

    var colorType = Check;

    if (value.first >= 22 || value.second >= 20 || value.third >= 19) {
        if (value >= 24 || value.second >= 22 || value.third >= 17) {
            colorType = Error;
        }
        else {
            colorType = Warning;
        }
    }

    return (

        colorType

    )
}

const SevereWearDot = () => {
    var colorType = Check;
    var value = 6;
    if (value >= 5) {
        if (value >= 10) {
            colorType = Error;
        }
        else {
            colorType = Warning;
        }
    }

    return (
        colorType
    )
}
const AirContentDot = () => {
    var colorType = Check;

    if (air >= 5) {
        if (air >= 10) {
            colorType = Error;
        }
        else {
            colorType = Warning;
        }
    }

    return (
        colorType
    )
}

const ISOPaper = (color1,text, value, type ) =>{



    return(
        
        <Grid 
             container
                 direction="column"
                justifyContent="space-evenly"
                alignItems="center"
                style={{opacity:"1"}}

        >
            <Stack direction="row" marginBottom={"-18px"} marginTop={"-10px"}
            
            
            >

            <div></div>

            <Paper  style={{ width:"60px" ,minWidth:"50px",height:"20px",backgroundColor:PaperColor, marginBottom:"12px"}}>
               <h6  style={{color:"white"}}> 

                  {text}
          
               </h6>
            </Paper>

           
            {text == "ISO 14" ? <ErrorOutlineIcon  fontSize="medium" style={{ color: red, marginLeft:"10px", paddingBottom:"-10px", marginBottom:"0px" }}/> :   <div></div>}
         
            </Stack>

            <ISO4406Meter OilTemp={value} type={type} />
        </Grid>

       
    )
}

